import { providerLimitValues } from './provider-limit-values';
export var hasUserEqualOrGreaterThan3000AvailableLimit = function (merchantResponseData, provider) {
    var limitValues = providerLimitValues(merchantResponseData, provider);
    return limitValues && limitValues.available >= 3000;
};
